import { AnnouncementsService } from '../shared/announcements.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
// import * as $ from 'jquery';
// import 'semantic-ui-calendar';
// import 'semantic-ui-css';
// import $ from 'jquery';
// declare let $: JQueryStatic;

@Component({
  selector: 'app-announcement-edit',
  templateUrl: './announcement-edit.component.html',
  styleUrls: ['./announcement-edit.component.css'],
})
export class AnnouncementEditComponent implements OnInit {
  editMode: Boolean = false;
  isSubmitting: Boolean = false;
  isDeleting: Boolean = false;
  openDropdown: Boolean = false;

  icons: String[] = ['paper', 'help-circle', 'information-circle', 'remove-circle', 'bus', 'time', 'warning'];
  routes: any[] = [];

  categories: any[] = [
    { id: 'homepage', name: 'Điều chỉnh tuyến' },
    { id: 'news', name: 'Tin tức' },
  ];

  types: any[] = [
    { id: 'url', name: 'Trang web' },
    { id: 'markdown', name: 'Văn bản Markdown' },
  ];

  announcement: any = {
    content: [],
    ts: moment().format('YYYY-MM-DDTHH:mm'),
    startDate: moment().format('YYYY-MM-DDTHH:mm'),
    endDate: moment().format('YYYY-MM-DDTHH:mm'),
    icon: { name: this.icons[0], color: 'primary' },
    _type: 'url',
    cat: 'other',
    route: '',
  };

  contentRaw: string;

  constructor(
    private route: ActivatedRoute,
    private service: AnnouncementsService,
    private router: Router,
    private location: Location
  ) {
    //
  }

  get(id: string) {
    this.service.get(id).subscribe((announcement) => {
      announcement.ts = moment(announcement.ts).format('YYYY-MM-DDTHH:mm');
      announcement.startDate = moment(announcement.startDate).format('YYYY-MM-DDTHH:mm');
      announcement.endDate = moment(announcement.endDate).format('YYYY-MM-DDTHH:mm');

      if (announcement.content) {
        this.contentRaw = announcement.content.join('/n');
      }
      this.editMode = true;
      this.announcement = announcement;
    });
  }

  delete() {
    this.isDeleting = true;
  }

  confirmDeleting(announcement: IAnnouncement) {
    this.service.remove(announcement._id).subscribe((result) => {
      this.router.navigate(['/announcements']);
    });
  }

  abortDeleting() {
    this.isDeleting = false;
  }

  prepDataForSummit(announcement: IAnnouncement) {
    if (this.contentRaw) {
      announcement.content = this.contentRaw.split('/n');
    }

    announcement.ts = moment(announcement.ts, 'YYYY-MM-DDTHH:mm').format();
    announcement.startDate = moment(announcement.startDate, 'YYYY-MM-DDTHH:mm').format();
    announcement.endDate = moment(announcement.endDate, 'YYYY-MM-DDTHH:mm').format();

    return announcement;
  }

  create(announcement: IAnnouncement) {
    this.isSubmitting = true;
    announcement = this.prepDataForSummit(announcement);

    this.service.create(announcement).subscribe((result) => {
      this.isSubmitting = false;
      this.router.navigate(['/announcements', result._id]);
    });
  }

  update(announcement: IAnnouncement) {
    this.isSubmitting = true;
    announcement = this.prepDataForSummit(announcement);

    this.service.update(announcement._id, announcement).subscribe((result) => {
      this.isSubmitting = false;
      this.router.navigate(['/announcements', result._id]);
    });
  }

  cancel() {
    this.location.back();
  }

  toggleDropdown(status) {
    this.openDropdown = !status;
  }

  chooseRoute(route: any, status) {
    this.toggleDropdown(status);
    this.announcement.route = route._id;
  }

  getRouteValue(id) {
    let value = '';
    if (this.routes && this.routes.length > 0) {
      this.routes.forEach((route) => {
        if (id === route._id) {
          value = route.number + ' - ' + route.name;
        }
      });
    }
    return value;
  }

  ngOnInit() {
    //
    const params = this.route.snapshot.params;

    const id = params['id'];
    if (id) {
      this.get(id);
    }

    this.service.getAllRoutes().subscribe((result) => {
      if (result && result.length > 0) {
        this.routes = result;
      }
    });
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/announcements/announcement-edit/announcement-edit.component.ts